import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import { Dialog } from "components/layout/dialogs/Dialog";
import { DialogProperties } from "components/layout/dialogs/DialogProperties";
import { useState } from "react";

export function PilotageToTimeDialog({ value, onClose, onSave }) {
    const [arrivalTime, setArrivalTime] = useState(value);

    const handleOnSave = async () => {
        await onSave(arrivalTime);
    }

    const handleOnChange = (e) => {
        setArrivalTime(e.value);
    }

    return (
        <Dialog
            properties={{
                ...DialogProperties,
                mode: "confirmation",
                title: "Estimert sluttid",
                className: "dialog-title",
                onClose: onClose,
                closeText: "Avbryt",
                onClick: handleOnSave,
                clickText: "Lagre",
            }}
        >
            <div>
                <DateTimePicker
                    title="Estimert sluttid"
                    value={arrivalTime}
                    onChange={handleOnChange}
                    canDelete={false}
                />
            </div>
        </Dialog>
    );
}
